
class ClientAccountingViewController extends MUIViewController
{
    static newInstance() : ClientAccountingViewController
    {
        let vc = new ClientAccountingViewController("client-accounting-view");
        vc.initWithResource("layout/clients/ClientAccountingView.html");
        return vc;
    }

    private salesLedgerAccountDropdown:MUIButton = null;
    private purchaseLedgerAccountDropdown:MUIButton = null;
    //private accountNumberTextField:MUITextField = null;

    private addBankInfoButton:MUIButton = null;
    private bankInfoTable:UITableView = null;
    
    private defaultBankAccountDropdown:MUIButton = null;    
    private defaultRateDropdown:MUIButton = null;
    private defaultPaymentDropdown:MUIButton = null;
    private extraTaxDropdown:MUIButton = null;
    private vatType:MUIComboBox = null;

    private bankInfoDataSource:ClientBankInfoDataSource = null;
    private _taxRegimeTypes:TaxRegimeType[] = [];

    viewDidLoad(): void {

        this.salesLedgerAccountDropdown = MUIOutlet(this, "sales-ledger-account-dd", "MUIButton");
        this.salesLedgerAccountDropdown.setAction(this, function(this:ClientAccountingViewController){
            AppHelper.sharedInstance().showSelectLedgerAccountViewControllerFromView(this.salesLedgerAccountDropdown, this._client.salesLedgerAccount, null, false, this._client.name, this, this.updateSalesLedgerAccount);
        });

        this.purchaseLedgerAccountDropdown = MUIOutlet(this, "purchase-ledger-account-dd", "MUIButton");
        this.purchaseLedgerAccountDropdown.setAction(this, function(this:ClientAccountingViewController){
            AppHelper.sharedInstance().showSelectLedgerAccountViewControllerFromView(this.purchaseLedgerAccountDropdown, this._client.purchaseLedgerAccount, null, false, this._client.name, this, this.updatePurchaseLedgerAccount);
        });

        // this.accountNumberTextField = MUIOutlet(this, "account-number-tf", "MUITextField");
        // this.accountNumberTextField.setOnChangeText(this, function(this:ClientAccountingViewController, control:MUITextField, value:string){
        //     let v = value.trim().length > 0 ? value : null;
        //     this._client.accountNumber = v;
        // });
        
        this.defaultBankAccountDropdown = MUIOutlet(this, "default-bank-dd", "MUIButton");
        this.defaultBankAccountDropdown.setAction(this, function(this:ClientAccountingViewController){
            AppHelper.sharedInstance().showSelectBankInfoViewControllerFromView(this.defaultBankAccountDropdown, this._client, this, function(this:ClientAccountingViewController, controller:any, object:LegalEntityBankAccountInfo){
                this._client.defaultBankAccount = object;
                this._client.defaultBankAccountName = object?.title;
                this.defaultBankAccountDropdown.title = object?.title;
            });
        });

        this.defaultRateDropdown = MUIOutlet(this, "default-rate-dd", "MUIButton");
        this.defaultRateDropdown.setAction(this, function(this:ClientAccountingViewController) {
            AppHelper.sharedInstance().showSelectRateViewControllerFromView(this.defaultRateDropdown, this._client.rate, this, function(this:ClientAccountingViewController, controller:any, object:Rate){
                this._client.rate = object;
                this.defaultRateDropdown.title = object?.name;
            });
        });

        this.defaultPaymentDropdown = MUIOutlet(this, "default-payment-dd", "MUIButton");
        this.defaultPaymentDropdown.setAction(this, function(this:ClientAccountingViewController) {
            AppHelper.sharedInstance().showSelectPaymethodViewControllerFromView(this.defaultPaymentDropdown, this._client.defaultPayMethod, this, function(this:ClientAccountingViewController, controller:any, object:PayMethod){
                this._client.defaultPayMethod = object;
                this._client.defaultPayMethodName = object?.name;
                this.defaultPaymentDropdown.title = object?.name;
            });
        });


        // The retention the customer is obliged to apply: its invoices carry it, the others carry none
        this.extraTaxDropdown = MUIOutlet(this, "extra-tax-dd", "MUIButton");
        this.extraTaxDropdown.setAction(this, function(this:ClientAccountingViewController){
            AppHelper.sharedInstance().showSelectLegalEntityTaxViewControllerFromView(this.extraTaxDropdown, this._client.legalTax, this, this.updateLegalEntityTax);
        });

        this.vatType = MUIOutlet( this, "vat-type-cb", "MUIComboBox" );
        this.vatType.setOnChangeAction( this, function(this:ClientAccountingViewController, control:MUIComboBox, value:string) {
            let index = parseInt( value );
            if (index >= 0 && index < this._taxRegimeTypes.length) {
                this._client.taxRegimeType = this._taxRegimeTypes[index].value;
            }
        });

        this.loadTaxRegimeTypes();

        this.addBankInfoButton = MUIOutlet(this, "bank-account-add-btn", "MUIButton");
        this.addBankInfoButton.setAction( this, this.addBankAccountAction);

        this.bankInfoTable = MUIOutlet(this, "bank-accounts-table-view", "UITableView");
        this.bankInfoDataSource = new ClientBankInfoDataSource();
        this.bankInfoDataSource.initWithTableView( this.bankInfoTable );

        this.bankInfoTable.dataSource = this.bankInfoDataSource;
        this.bankInfoTable.delegate = this.bankInfoDataSource as any;
    }

    viewWillAppear(animated?){
        super.viewWillAppear(animated);
        this.updateUI();
    }

    private _client:Client = null;
    set client(client:Client){
        this._client = client;
        this.updateUI();
    }
    
    private updateUI(){
        if (this.viewIsLoaded == false || this._client == null) return;
        
        this.bankInfoDataSource.client = this._client;

        this.salesLedgerAccountDropdown.title = this._client.salesLedgerAccountName;
        this.purchaseLedgerAccountDropdown.title = this._client.purchaseLedgerAccountName;
        // this.accountNumberTextField.text = this._client.accountNumber;

        this.defaultBankAccountDropdown.title = this._client.defaultBankAccount?.title;
        this.defaultRateDropdown.title = this._client.rate?.name;
        this.defaultPaymentDropdown.title = this._client.defaultPayMethodName;
        this.extraTaxDropdown.title = this._client.legalTaxName ?? MIOLocalizeString("NONE", "NONE");

        this.selectCurrentTaxRegime();
    }

    private loadTaxRegimeTypes(){
        let sds = [MIOSortDescriptor.sortDescriptorWithKey("value", true)];
        DBHelper.queryObjectsWithCompletion("TaxRegimeType", sds, null, [], this, function(this:ClientAccountingViewController, objects:TaxRegimeType[]) {
            this._taxRegimeTypes = objects ?? [];
            this.vatType.removeAllItems();
            for (let i = 0; i < this._taxRegimeTypes.length; i++) {
                this.vatType.addItem(this._taxRegimeTypes[i].title, i);
            }
            this.selectCurrentTaxRegime();
        });
    }

    private selectCurrentTaxRegime(){
        if (this._client == null || this._taxRegimeTypes.length == 0) return;
        for (let i = 0; i < this._taxRegimeTypes.length; i++) {
            if (this._taxRegimeTypes[i].value == this._client.taxRegimeType) {
                this.vatType.selectItem(i);
                return;
            }
        }
    }

    private addBankAccountAction(){
        let avc = new MUIAlertViewController();
        avc.initWithTitle(MIOLocalizeString("ACTIONS","ACTIONS"), MIOLocalizeString("CHOOSE_AN_ACTION", "CHOOSE AN ACTION"), MUIAlertViewStyle.Default);

        avc.addTextFieldWithConfigurationHandler( this, function(control:MUITextField) {
            control.placeholderText = MIOLocalizeString("TITLE", "TITLE");  
        });

        avc.addTextFieldWithConfigurationHandler( this, function(control:MUITextField) {
            control.placeholderText = MIOLocalizeString("ACCOUNT", "ACCOUNT");  
        });

        avc.addTextFieldWithConfigurationHandler( this, function(control:MUITextField) {
            control.placeholderText = MIOLocalizeString("BANK_CODE", "BANK CODE");  
        });

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("OK", "OK"), MUIAlertActionStyle.Cancel, this, function(this:ClientAccountingViewController){
            let title = avc.textFields[0].text;
            let account = avc.textFields[1].text;
            let code = avc.textFields[2].text;

            this.createBankAccount(title.trim(), account.trim(), code.trim());

        }));

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("CANCEL", "CANCEL"), MUIAlertActionStyle.Cancel, null, null));

        AppHelper.sharedInstance().presentViewController(avc, true);

    }

    private createBankAccount(title:string, account:string, code:string){
        if (title.length == 0 || account.length == 0 ) {
            AppHelper.showErrorMessage(this, "Error creating", "Title or account can not be empty");
            return;
        }

        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        let info = MIOEntityDescription.insertNewObjectForEntityForName( "LegalEntityBankAccountInfo", ad.managedObjectContext) as LegalEntityBankAccountInfo;
        info.title = title;
        info.iban = account;
        info.number = account;
        info.bankCode = code.length > 0 ? code : null;
        info.legalEntity = this._client;


        DBHelper.saveMainContext();
    }

    private updateSalesLedgerAccount(controller:SelectViewController, account:LedgerAccount){
        this._client.salesLedgerAccount = account;
        this._client.salesLedgerAccountName = account?.description;
        this.salesLedgerAccountDropdown.title = account?.description;
    }

    private updatePurchaseLedgerAccount(controller:SelectViewController, account:LedgerAccount){
        this._client.purchaseLedgerAccount = account;
        this._client.purchaseLedgerAccountName = account?.description;
        this.purchaseLedgerAccountDropdown.title = account?.description;
    }

    private updateLegalEntityTax(controller:SelectViewController, tax:LegalTax){
        this._client.legalTax = tax;
        this._client.legalTaxName = tax?.name;
        this.extraTaxDropdown.title = tax?.name ?? MIOLocalizeString("NONE", "NONE");
    }


}